import { Customer } from "../Model/Customer";

/**
 * Transforms the inputs of the form into a customer object.
 */
export class CustomerToDataTransformer {

  to(customer) {
    let data = {
      first_name: customer.getFirstName(),
      last_name: customer.getLastName(),
      email: customer.getEmail(),
      phone_number: customer.getPhoneNumber(),
      postal_code: customer.getPostalCode(),
      additional_comments: customer.getComment(),
      privacy_policy: customer.hasPrivacyPolicy(),
      subscribed_to_newsletter: customer.isSubscribed()
    };

    let contacts = customer.getSubscriptions().filter((element) => {
      return element !== null;
    });

    if (contacts) {
      data.contacts = contacts;
    }

    return data;
  }

  from(data) {
    let customer = new Customer()
      .setId(data.id)
      .setFirstName(data.firstName)
      .setLastName(data.lastName)
      .setEmail(data.email)
      .setPostalCode(data.postalCode)
      .setPhoneNumber(data.phoneNumber)
      .setComment(data.additionalComments)
      .setPrivacyPolicy(data.privacyPolicy)
      .setSubscribed(data.subscribedToNewsletter);

    if (data.contacts.length > 0) {
      let contacts = data.contacts.map((contact) => contact.key);
      customer.setSubscriptions(contacts);
    }

    return customer;
  }

}
